import type { ToolCallHistoryStep } from '@/stores/local/shared/ToolCallHistoryStore/types';

export const STEP_KIND_LABEL: Record<ToolCallHistoryStep['kind'], string> = {
  call: 'Действие',
  result: 'Результат',
  status: 'Статус',
  information_sources: 'Источники',
  // Для tool_interaction заголовок берётся из step.displayName, метка не показывается
  tool_interaction: '',
};

export const TOOL_CALL_STEP_COLLAPSE_THRESHOLD = 300;
